import { render, staticRenderFns } from "./societeDetails.html?vue&type=template&id=2562d510&scoped=true&external"
import script from "./societeDetails.js?vue&type=script&lang=js&external"
export * from "./societeDetails.js?vue&type=script&lang=js&external"
import style0 from "./societeDetails.scss?vue&type=style&index=0&id=2562d510&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2562d510",
  null
  
)

export default component.exports